/**
 * Código de erro que o backend devolveu — `{ error: "ERR_X" }`, ou
 * `"ERR_X: detalhe"`, ou só a mensagem de um Error.
 *
 * É a mesma extração que o toastError faz para traduzir; fica separada para
 * quem precisa REAGIR a um código específico (ex.: conexão de outro servidor)
 * e não só mostrar o toast. Os códigos vêm do core-contracts (`errors/`).
 *
 * @returns {string|null}
 */
export function backendErrorCode(err) {
  const raw =
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    err?.message ||
    err?.error;
  if (!raw || typeof raw !== "string") return null;
  return raw.split(":")[0].trim() || null;
}
